var map = {
	"./kv-banner-lt-chs.png": 7545,
	"./kv-banner-lt-cht.png": 28777,
	"./kv-banner-lt-en.png": 58433,
	"./kv-banner-lt-jp.png": 53689,
	"./kv-banner-lt-kr.png": 79956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80729;